import { lazy } from 'react'

import { authRoles } from '../../../../../auth/authRoles'
import Loadable from '../../../../base/components/Template/Loadable/Loadable'

const AppEmailGestion = Loadable(lazy(() => import('./view/listado/Email')))
const AppEmailNuevo = Loadable(lazy(() => import('./view/registro/EmailRegistro')))
const AppEmailActualizar = Loadable(lazy(() => import('./view/actualizar/EmailActualizar')))
export const emailRoutesMap = {
  gestion: {
    path: '/empresa/email',
    name: 'Clientes Correo',
    actionSecure: 'administrar',
  },
  nuevo: {
    path: '/empresa/email/nuevo',
    name: 'Nuevo Cliente Correo',
  },
  modificar: {
    path: `/empresa/email/modificar`,
    name: 'Consultar Cliente Correo',
  },
}

const emailRoutes = [
  {
    path: emailRoutesMap.gestion.path,
    element: <AppEmailGestion />,
    auth: authRoles.admin,
  },
  {
    path: emailRoutesMap.nuevo.path,
    element: <AppEmailNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${emailRoutesMap.modificar.path}/:id`,
    element: <AppEmailActualizar />,
    auth: authRoles.admin,
  },
]

export default emailRoutes
